// extracted by mini-css-extract-plugin
export default {"menuItemIcon":"dotsTable_menuItemIcon__1-toX"};